(() => {
  if (customElements.get('lg-order-status')) return;

  class LGOrderStatus extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._start = () => {
        if (!this.isConnected || this._started) return;
        this._started = true;
        this._productInfo = this.closest('product-info');
        if (!this._productInfo) return;

        this._onChange = (event) => {
          if (event.target.closest('variant-radios, variant-selects')) {
            this.hidden = true;
          }
        };
        this._productInfo.addEventListener('change', this._onChange, true);

        if (typeof subscribe === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            const sectionId = this._productInfo.dataset.originalSection ||
                              this._productInfo.dataset.section;
            if (!data || String(data.sectionId) !== String(sectionId)) return;
            const updated = data.html && data.html.getElementById(this.id);
            if (!updated) {
              this.hidden = true;
              return;
            }
            this.innerHTML = updated.innerHTML;
            this.hidden = updated.hasAttribute('hidden');
          });
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._start, { once: true });
      } else {
        this._start();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this._start);
      if (this._productInfo && this._onChange) {
        this._productInfo.removeEventListener('change', this._onChange, true);
      }
      if (this._unsubscribe) this._unsubscribe();
      this._unsubscribe = null;
      this._started = false;
      this._connected = false;
    }
  }
  customElements.define('lg-order-status', LGOrderStatus);
})();
